import { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BzHeading } from "../../../components";


const Summmary = ({ portfolioSumaary }) => {

    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0 justify-content-center mt-3'>
                    <Col md={6} className='flex-column justify-content-start'>
                        <div className='funds-card-wrapper mt-4 mx-4 p-4 bdr-radius-10'>
                            <Row className='g-0'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <div className='icon-16 icon-portfolio icon-dark me-3'>&nbsp;</div>
                                    <BzHeading className='font-medium font-size6 color-text text-uppercase'>SUMMARY</BzHeading>
                                </Col>
                            </Row>
                            <Row className='g-0 pt-4'>
                                <Col>
                                    <BzHeading className='font-regular font-size1 color-subtext'>Current Value</BzHeading>
                                    <div className='font-medium font-size8 color-text'>&#8377;{portfolioSumaary[0]?.current_value}</div>
                                    <div className='font-regular font-size3 color-text color-positive'>+₹50.82 (2.45%)</div>
                                </Col>
                                <Col>
                                    <BzHeading className='font-regular font-size1 color-subtext'>Invested</BzHeading>
                                    <div className='font-medium font-size8 color-text'>&#8377;{portfolioSumaary[0]?.total_invested}</div>
                                </Col>
                                <Col>
                                    <BzHeading className='font-regular font-size1 color-subtext'>Today's P/L</BzHeading>
                                    <div className='font-regular font-size6 color-text color-positive'>{portfolioSumaary[0]?.today_p_l}</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col className='d-flex pt-4'>
                                    <Row className='g-0'>
                                        <Col className='d-flex align-items-center justify-content-start pe-4'>
                                            <div className='font-medium font-size4 color-primary me-2'>Register Mandate</div>
                                            <div className='icon-16 icon-info icon-primary'></div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0'>
                                        <Col className='d-flex align-items-center justify-content-start'>
                                            <div className='font-medium font-size4 color-primary me-2'>Mandate Report</div>
                                            <div className='icon-16 icon-info icon-primary'></div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default memo(Summmary);